import React, { useReducer } from "react";
import ResultadoDetalleReducer from "./resultadoDetalleReducer";
import ResultadoDetalleContext from "./resultadoDetalleContext";
import clienteAxios from "../../config/axios";

import {
  OBTENER_RESULTADO_DETALLE,
  ERROR_OBTENER_RESULTADO_DETALLE,
  OBTENER_VALIDACION,
  ERROR_OBTENER_VALIDACION,
  OBTENER_ARCHIVOS_DETALLE,
  ERROR_OBTENER_ARCHIVOS_DETALLE,
  OBTENER_ARCHIVOS_DETALLE_PDF,
  ERROR_OBTENER_ARCHIVOS_DETALLE_PDF,
} from "../../types";

const ResultadoDetalleState = (props) => {
  const inicialState = {
    id: 0,
    paciente: "",
    medico: "",
    fecha: "",
    institucion: "",
    sexo: "",
    edad: "",
    fechaImpresion: "",
    sucursalNombre: "",
    sucursalDireccion: "",
    fechaNacimiento: "",
    fechaValidacion: "",
    folio: "",
    muestra: "",
    metodo: "",
    estudios: [],
    resultadoMedico: [],
    archivosDigitales: [],
    archivosDigitalesPDF: [],
    resultadoInterpretacion: "",
    dataGrafica: "",
    optionsGrafica: "",
    qr: "",
    QRProveedor: "",
    nombreTipoOrden: "",
    validacion: null,
  };

  const [state, dispatch] = useReducer(ResultadoDetalleReducer, inicialState);

  const obtenerDetalleResultados = async (id) => {
    try {
      const respuesta = await clienteAxios.get(`/resultados/${id}`);
      debugger;
      const r = respuesta.data;
      console.log("97", r);
      if (r.length !== 0) {
        dispatch({
          type: OBTENER_RESULTADO_DETALLE,
          payload: r,
        });
      } else {
        dispatch({
          type: ERROR_OBTENER_RESULTADO_DETALLE,
        });
      }
    } catch (error) {
      dispatch({
        type: ERROR_OBTENER_RESULTADO_DETALLE,
      });
    }
  };

  const validarResultado = async (oid, id) => {
    try {
      const respuesta = await clienteAxios.get(`/resultados/${oid}/${id}`);
      const r = respuesta.data;

      if (r.length !== 0) {
        dispatch({
          type: OBTENER_VALIDACION,
          payload: r,
        });
      } else {
        dispatch({
          type: ERROR_OBTENER_VALIDACION,
        });
      }
    } catch (error) {
      dispatch({
        type: ERROR_OBTENER_VALIDACION,
      });
    }
  };
  const obtenerArchivosDigitalesv2 = async (id) => {
    try {
      const respuesta = await clienteAxios.get(`/storage/${2}/${964}/${id}/v2`);

      const r = respuesta.data;

      if (r.length !== 0) {
        let arr = r;
        console.log("97", arr);
        arr = arr.filter((item) => !(item.filename == "deleteme.$$$"));
        dispatch({
          type: OBTENER_ARCHIVOS_DETALLE,
          payload: arr,
        });
      } else {
        dispatch({
          type: ERROR_OBTENER_ARCHIVOS_DETALLE,
        });
      }
    } catch (error) {
      dispatch({
        type: ERROR_OBTENER_ARCHIVOS_DETALLE,
      });
    }
  };
  const obtenerArchivosDigitales = async (id) => {
    try {
      const respuesta = await clienteAxios.get(`/storage/${2}/${964}/${id}`);

      const r = respuesta.data;

      if (r.length !== 0) {
        let arr = r;
        //arr = arr.filter((item) => !(item.filename == "deleteme.$$$"));
        console.log(arr);
        dispatch({
          type: OBTENER_ARCHIVOS_DETALLE_PDF,
          payload: arr,
        });
      } else {
        dispatch({
          type: ERROR_OBTENER_ARCHIVOS_DETALLE_PDF,
        });
      }
    } catch (error) {
      dispatch({
        type: ERROR_OBTENER_ARCHIVOS_DETALLE_PDF,
      });
    }
  };

  return (
    <ResultadoDetalleContext.Provider
      value={{
        id: state.id,
        paciente: state.paciente,
        medico: state.medico,
        fecha: state.fecha,
        institucion: state.institucion,
        sexo: state.sexo,
        edad: state.edad,
        fechaImpresion: state.fechaImpresion,
        sucursalNombre: state.sucursalNombre,
        sucursalDireccion: state.sucursalDireccion,
        fechaNacimiento: state.fechaNacimiento,
        fechaValidacion: state.fechaValidacion,
        folio: state.folio,
        muestra: state.muestra,
        metodo: state.metodo,
        estudios: state.estudios,
        resultadoMedico: state.resultadoMedico,
        resultadoInterpretacion: state.resultadoInterpretacion,
        dataGrafica: state.dataGrafica,
        optionsGrafica: state.optionsGrafica,
        qr: state.qr,
        QRProveedor: state.QRProveedor,
        nombreTipoOrden: state.nombreTipoOrden,
        validacion: state.validacion,
        obtenerDetalleResultados,
        validarResultado,
        obtenerArchivosDigitalesv2,
        obtenerArchivosDigitales,
        archivosDigitales: state.archivosDigitales,
        archivosDigitalesPDF: state.archivosDigitalesPDF,
      }}
    >
      {props.children}
    </ResultadoDetalleContext.Provider>
  );
};

export default ResultadoDetalleState;
